import React, { useEffect, useState } from "react";
import "./pdfView.css";
import { Document, Page, pdfjs } from "react-pdf";
import { useParams } from "react-router-dom";
import { getProduct, getProducts } from "../axios";

pdfjs.GlobalWorkerOptions.workerSrc = `//unpkg.com/pdfjs-dist@${pdfjs.version}/legacy/build/pdf.worker.min.js`;

const PdfViewDemo = (id) => {
  const [numPages, setNumPages] = useState(null);
  const [pageNumber, setPageNumber] = useState(1);

  let params = useParams();
  const [result, setResult] = useState();
  useEffect(() => {
    // getProducts().then(({ data }) => {
    //   const filterProduct = data.filter((p) => p.id == params.id);
    //   setResult(filterProduct);
    // });
    // console.log(params)
    getProduct(params.id).then(({ data }) => {
      setResult(data[0]);
    });
  }, [params]);

  const onDocumentLoadSuccess = ({ numPages }) => {
    setNumPages(numPages);
  };

  const nextPage = () => {
    if (pageNumber < numPages) {
      setPageNumber(pageNumber + 1);
    }
  };

  const prevPage = () => {
    if (pageNumber > 1) {
      setPageNumber(pageNumber - 1);
    }
  };

  const styles = {
    page: {
      backgroundColor: "white",
    },
    viewer: {
      width: window.innerWidth, //the pdf viewer will take up all of the width and height
      height: window.innerHeight,
    },
  };
  // d-flex align-items-center justify-content-center m-auto w-100
  return (
    <div className="bar ">
      <div
        className="wrap text-center"
        onContextMenu={(e) => e.preventDefault()}
      >
        <div className="controls" onContextMenu={(e) => e.preventDefault()}>
          <button
            className="btn btn-sm btn-light d-flex align-items-center justify-content-center"
            style={{ height: "40px" }}
            onClick={prevPage}
            disabled={pageNumber === 1}
          >
            قبلی
          </button>
          <button
            className="btn btn-sm btn-light d-flex align-items-center justify-content-center"
            style={{ height: "40px" }}
            onClick={nextPage}
            disabled={pageNumber === numPages}
          >
            بعدی
          </button>
        </div>

        <Document
          file={result && result.filedemo}
          onLoadSuccess={onDocumentLoadSuccess}
          onContextMenu={(e) => e.preventDefault()}
          className="pdf-contailner"
        >
          <Page
            scale={2} // Increase scale to improve resolution
            renderTextLayer={false} // Disable text layer to avoid overlap issues
            renderAnnotationLayer={false} // Disable annotations for cleaner display
            style={styles.page}
            pageNumber={pageNumber}
            onContextMenu={(e) => e.preventDefault()}
          />
        </Document>
      </div>
    </div>
  );
};

export default PdfViewDemo;
